import { View } from 'ckeditor5'
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { VIEW } from '../../components/image'
import StoriesList from './StoriesList'
import Regions from '../../components/videoStatistics/Regions'

const VideoStatistics = () => {
    const [active, setActive] = useState('Story List');

    return (
        <div className='container1 container'>
            <div className="data-table activityTable">
                <div className="title">
                    <ion-icon name="stats-chart-outline"></ion-icon>
                    <span className="text">Video Statistics</span>
                </div>

                <div className="d-flex">
                    <div onClick={() => (setActive('Story List'))} className={`usersNav ${active == 'Story List' && 'usersNav-active'}`}>
                        Story List
                    </div>
                    <div onClick={() => (setActive('Regions'))} className={`ms-4 usersNav ${active == 'Regions' && 'usersNav-active'}`}>
                        Regions
                    </div>
                </div>

                {
                    active == 'Story List' && (
                        <StoriesList />
                    )
                }
                {
                    active == 'Regions' && (
                        <Regions />
                    )
                }


            </div>
        </div >
    )
}

export default VideoStatistics
